import { FieldInputProps } from 'formik';
import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';

interface IProps extends FieldInputProps<string> {
    disabled?: boolean;
    placeholder?: string;
    hasFileUploaded?: boolean;
}

export default function TextAreaInput(props: IProps) {
    const { disabled, placeholder, hasFileUploaded, value, ...restProps } = props;
    const textareaRef = useRef<HTMLTextAreaElement>();

    useEffect(() => {
        const textarea = textareaRef.current;
        if (textarea) {
            const currentHeight = textarea.offsetHeight;
            const newHeight = Math.min(textarea.scrollHeight, 320);

            if (newHeight > currentHeight) {
                textarea.style.height = `${newHeight}px`;
            }
        }
    }, [value]);

    return (
        <textarea
            {...restProps}
            value={value}
            disabled={disabled}
            placeholder={placeholder}
            ref={textareaRef}
            className={clsx(
                'w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-cyan-800 sm:text-sm sm:leading-6',
                hasFileUploaded ? 'bg-gray-50 ring-gray-400' : 'bg-white ring-gray-300',
            )}
        />
    );
}
